import { render, staticRenderFns } from "./PreloadedIframeRiveLoader.vue?vue&type=template&id=5a07a5cd"
import script from "./PreloadedIframeRiveLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreloadedIframeRiveLoader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_babel-core@6.26.3_css-loader@6.11.0_webpack@5.111_qiwspig4cowntqqutyssg3tktu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports